export const PAYMENT_SERVICES = {
  SAFEWAY: 10486,
  PAYBROKERS: 10266,
  PARAI: 16900,
};
